import * as React from "react";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { Navigator } from "../../../../../../Shared/Wizards/Entities/Navigator";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { Typography } from "../../../../../../Shared/Typography/Typography";
import { Urls } from "../../../../../Urls";
import { IReviewProps, withdralalParse } from "../ReviewParser";
import { NewQuoteAction } from "../../../NewQuoteWizard/Actions/NewQuoteAction";

export const WithDrawalReview = (props: IReviewProps) => {
    const { data, subAccountType, process, onEditAction } = props;

    const navigate = () => {
        if (process == ProcessType.NB) {
            Navigator.navigateToAndPreserveQueryParameters(withDrawalUrlConfig());
        } else if (process == ProcessType.Quote) {
            withDrawalUrlConfigForNewQuote();
        }
    };

    const withDrawalUrlConfigForNewQuote = () => {
        switch (subAccountType) {
            case SubAccountType.InvestmentAccount:
                return NewQuoteAction.copyQuoteInstruction(Urls.get().QuoteWithdrawalsPP);
            case SubAccountType.StocksIsa:
                return NewQuoteAction.copyQuoteInstruction(Urls.get().QuoteWithdrawalsISA);
            default:
                break;
        }
    };

    const withDrawalUrlConfig = () => {
        switch (subAccountType) {
            case SubAccountType.InvestmentAccount:
                return Urls.get().NBWithdrawalsPP;
            case SubAccountType.StocksIsa:
                return Urls.get().NBWithdrawalsISA;
            default:
                break;
        }
    };

    const withDrawalConfig = () => {
        if (!data) {return [];}
        const config = [];
        const regularWithdrawalArr = withdralalParse(data.RegularWithdrawalModel, process);
        regularWithdrawalArr.map((ele, index) => {
            config.push({ title: "Withdrawal " + (index + 1), data: ele });
        });
        return config;
    };

    return (
        <Accordion
            label="Withdrawal details"
            isOpen={false}
            onEdit={() => (onEditAction ? onEditAction() : navigate())}
        >
            <div className="pl-34">
                <Typography type="common" wrapCss="white-space-pre" config={withDrawalConfig()}></Typography>
            </div>
        </Accordion>
    );
};
